import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
// Global type declarations
declare global {
  interface Window {
    fbq: any;
    hj: any;
    _hjSettings: any;
    dataLayer: any[];
    gtag: (...args: any[]) => void;
    adverfly: any[];
    advPxl: (...args: any[]) => void;
  }
}
// Initialize tracking scripts
if (typeof window !== 'undefined') {
  // Initialize Adverfly
  const loadAdverfly = () => {
    function advPxl() {
      const args = [false];
      for (let i = 0; i < arguments.length; i++) {
        args.push(arguments[i]);
      }
      window.adverfly.push(args);
    }
    window.adverfly = window.adverfly || [];
    window.advPxl = advPxl;
    advPxl('init', 830196);
    window.adverfly.store_currency = 'EUR';
    window.adverfly.store_timezone = 'Europe/Berlin';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://sos-de-fra-1.exo.io/adv/adv.js';
    document.getElementsByTagName('head')[0].appendChild(script);
    const script2 = document.createElement('script');
    script2.type = 'text/javascript';
    script2.async = true;
    script2.src = 'https://sos-de-fra-1.exo.io/adv/adv-830196.js';
    document.getElementsByTagName('head')[0].appendChild(script2);
  };
  loadAdverfly();
  // Initialize Google Analytics (gtag.js)
  const loadGoogleTagManager = () => {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-0V4DPRLGPK';
    document.head.appendChild(script);
    window.dataLayer = window.dataLayer || [];
    function gtag(...args: any[]) {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'G-0V4DPRLGPK');
  };
  loadGoogleTagManager();
  (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  window.fbq('init', '745024051787467');
  window.fbq('track', 'PageView');
  (function (h: any, o: any, t: any, j: any, a: any, r: any) {
    h.hj = h.hj || function () {
      ;
      (h.hj.q = h.hj.q || []).push(arguments);
    };
    h._hjSettings = {
      hjid: 6510844,
      hjsv: 6
    };
    a = o.getElementsByTagName('head')[0];
    r = o.createElement('script');
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
}
render(<AppRouter data-id="element-264" />, document.getElementById('root'));